import {ReduxStateType} from '../store';

export const selectDeductionSummary = (state: ReduxStateType) => {
  return state.deductionSummary;
};
